import React, { useState } from 'react';
import AllianceModal from '@components/common/modals/affiliateModal/affiliateList';
import Tab from '@components/common/tab';
import { useAffilliateCertificationStatus } from '@repository/partnership/usePartnership';
import { useCouponsRegistered } from '@repository/coupons/useCoupons';
import AffiliatedUniversityForm from './affiliatedUniversityForm';
import CompletedAffiliatedUniversityForm from './affiliatedUniversityForm/CompletedForm';
import CompletedVerificationCodeForm from './codeRegisterForm/CompletedForm';
import GuideList from './GuideList';
import { EventCodeRegisterForm, OrganizationCodeRegisterForm } from './codeRegisterForm';
import classnames from 'classnames/bind';
import styles from './premium.module.scss';

const cx = classnames.bind(styles);

const PremiumInfo = () => {
  const { data: registeredCoupons, refetch: refetchRegisteredCoupons } = useCouponsRegistered();
  const { data: allianceData, refetch: refetchAllianceData } = useAffilliateCertificationStatus();
  const isVerifiedUniversity = allianceData?.universityVerified;
  const isVerifiedOrganization = allianceData?.organizationVerified;
  const [allianceModalVisible, setAllianceModalVisible] = useState(false);

  if (!allianceData || !registeredCoupons) return null;

  return (
    <div className={cx('infoArea')}>
      <div className={cx('infoInner')}>
        <strong className={cx('title')}>제휴서비스 신청 관리</strong>

        <div className={cx('userInfoArea')}>
          <GuideList isCertified={!!isVerifiedUniversity || !!isVerifiedOrganization} />
          <div className={cx('btnArea')}>
            <a className={cx('btnAllianceList')} role="button" onClick={() => setAllianceModalVisible(true)}>
              제휴 리스트 확인하기
            </a>
          </div>
        </div>

        <div className={cx('userInfoArea')}>
          <Tab>
            <Tab.Item
              title={
                <>
                  제휴 대학 인증
                  {isVerifiedUniversity && <span className={cx('chip')}>완료</span>}
                </>
              }
              index="0"
            >
              {isVerifiedUniversity ? (
                <CompletedAffiliatedUniversityForm data={allianceData} refetchData={refetchAllianceData} />
              ) : (
                <AffiliatedUniversityForm refetchData={refetchAllianceData} />
              )}
            </Tab.Item>

            <Tab.Item
              title={
                <>
                  제휴 기업 인증
                  {isVerifiedOrganization && <span className={cx('chip')}>완료</span>}
                </>
              }
              index="1"
            >
              {isVerifiedOrganization ? (
                <CompletedVerificationCodeForm data={allianceData} refetchData={refetchAllianceData} />
              ) : (
                <OrganizationCodeRegisterForm refetchData={refetchAllianceData} />
              )}
            </Tab.Item>

            <Tab.Item
              title={
                <>
                  이벤트 인증
                  {registeredCoupons.hasVaildCoupons && <span className={cx('chip')}>완료</span>}
                </>
              }
              index="2"
            >
              <EventCodeRegisterForm data={registeredCoupons} refetchData={refetchRegisteredCoupons} />
            </Tab.Item>
          </Tab>
        </div>
      </div>

      <AllianceModal visible={allianceModalVisible} onClose={() => setAllianceModalVisible(false)} />
    </div>
  );
};

export default PremiumInfo;
